import React, { useContext, useMemo } from 'react';

import { ListContext } from '../ListContext';

export default function (WrappedComponent) {
	const ReturnedComponent = function (props) {
		const listContext = useContext(ListContext);

		const enchancedListContext = useMemo(() => ({
			...listContext,
			listId: props.listId,
			hideGeneralSettings: props.hideGeneralSettings,
		}), [listContext, props.hideGeneralSettings, props.listId]);

		return (
			// eslint-disable-next-line react/jsx-filename-extension
			<ListContext.Provider value={enchancedListContext}>
				<WrappedComponent
					{...props}
				/>
			</ListContext.Provider>
		);
	};

	return ReturnedComponent;
}


